// Same fix, same reasoning as the mobile app's app/utils/showtimeKey.js:
// the backend's `showtime` column (aserver/api, Postgres `user_tickets`) is
// a bare "h:mm AM/PM" string with no date, so assignAuditorium/
// getReservedSeats/confirmCheckout all match seat occupancy on
// (movieId, showtime, auditoriumId) alone - a seat sold for today's 7:00 PM
// showing stays "sold" for every future day's 7:00 PM showing too, since
// there's no date in the comparison at all.
//
// Only used for the three backend calls that check/write seat occupancy -
// never as a replacement for the plain `selectedTime` value used for display
// (the movie/showtime is chosen by whichever page links here as a ?time=
// query param).
export function getShowtimeKey(selectedTime) {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, '0');
  const d = String(today.getDate()).padStart(2, '0');
  return `${y}-${m}-${d} ${selectedTime}`;
}
